import { createStore, createLogger } from 'vuex';
import user, { UserState } from '@/store/modules/user';

export interface RootState {
  user: UserState;
}
const plugins = process.env.NODE_ENV !== 'production' ? [createLogger({})] : [];

export default createStore({
  plugins,
  modules: {
    user,
  },
});
